import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
} from "@/components/ui/dialog";
import { ShieldAlert, CheckCircle, XCircle } from "lucide-react";

const AgeVerification = () => {
  const [isOpen, setIsOpen] = useState(() => {
    // Check localStorage on initial render
    const verified = localStorage.getItem("age_verified");
    return !verified;
  });

  const handleAccept = () => {
    localStorage.setItem("age_verified", "true");
    setIsOpen(false);
  };

  const handleDecline = () => {
    window.location.href = "https://www.google.com";
  };

  return (
    <Dialog open={isOpen} onOpenChange={() => {}}>
      <DialogContent className="sm:max-w-lg p-0 bg-transparent border-0 shadow-none" hideClose>
        {/* Premium Card Design */}
        <div className="relative overflow-hidden rounded-2xl">
          {/* Background Gradient */}
          <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900"></div>
          
          {/* Animated Glow Effect */}
          <div className="absolute inset-0 opacity-30">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-96 h-96 bg-gradient-to-r from-pink-500 via-purple-500 to-pink-500 rounded-full blur-3xl animate-pulse"></div>
          </div>
          
          {/* Border Gradient */}
          <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-pink-500 via-purple-500 to-pink-500 p-[2px]">
            <div className="w-full h-full bg-slate-900 rounded-2xl"></div>
          </div>
          
          {/* Content */}
          <div className="relative z-10 p-8">
            {/* Logo/Icon Area */}
            <div className="flex justify-center mb-6">
              <div className="relative">
                <div className="w-20 h-20 bg-gradient-to-br from-pink-500 to-purple-600 rounded-2xl flex items-center justify-center shadow-lg shadow-pink-500/30">
                  <ShieldAlert className="w-10 h-10 text-white" />
                </div>
                <div className="absolute -bottom-1 -right-1 w-8 h-8 bg-red-500 rounded-full flex items-center justify-center border-4 border-slate-900">
                  <span className="text-white text-xs font-bold">18+</span>
                </div>
              </div>
            </div>
            
            {/* Title */}
            <h2 
              className="text-center text-2xl sm:text-3xl font-bold text-white mb-3"
              data-testid="age-verification-title"
              style={{fontFamily: 'Inter, sans-serif'}}
            >
              Age Verification
            </h2>
            
            {/* Subtitle */}
            <p className="text-center text-lg text-pink-400 font-medium mb-4">
              You must be 18+ to access this website
            </p>
            
            {/* Description */}
            <p className="text-center text-gray-400 text-sm mb-6 max-w-xs mx-auto">
              This website contains adult content and is intended for adults only. 
              By entering, you confirm that you are at least 18 years of age.
            </p>
            
            {/* Buttons */}
            <div className="space-y-3">
              <Button
                data-testid="age-verification-accept"
                onClick={handleAccept}
                className="w-full h-14 bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white text-lg font-semibold rounded-xl shadow-lg shadow-green-500/30 transition-all duration-300 hover:scale-[1.02]"
              >
                <CheckCircle className="w-5 h-5 mr-2" />
                I am 18 or older - Enter
              </Button>
              
              <Button
                data-testid="age-verification-decline"
                onClick={handleDecline}
                className="w-full h-14 bg-slate-800 hover:bg-slate-700 text-gray-300 text-lg font-medium rounded-xl border border-slate-700 hover:border-red-500/50 transition-all duration-300"
              >
                <XCircle className="w-5 h-5 mr-2 text-red-400" />
                I am under 18 - Exit
              </Button>
            </div>
            
            {/* Legal Notice */}
            <p className="text-center text-gray-500 text-xs mt-6">
              uplino.in follows all applicable laws and regulations.
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AgeVerification;
